import {
  HttpDeleteRequest,
  HttpGetRequest,
  HttpPostRequest,
  HttpPutRequest,
} from "./HttpRequest.js";

export async function create(careUnitDateRange) {
  let url = "/surgical_intervention_transfer";
  return await HttpPostRequest(url, careUnitDateRange).then((response) => {
    return response.json();
  });
}

export async function remove(careUnitDateRangeId) {
  let url = "/surgical_intervention_transfer/" + careUnitDateRangeId;
  return await HttpDeleteRequest(url).then((response) => {
    return response.json();
  });
}

export async function update(id, careUnitDateRange) {
  let url = "/surgical_intervention_transfer/" + id;
  return await HttpPutRequest(url, careUnitDateRange).then((response) => {
    return response.json();
  });
}

export async function getOne(careUnitDateRangeId) {
  let url = "/surgical_intervention_transfer/" + careUnitDateRangeId;
  return await HttpGetRequest(url).then((response) => {
    return response.json();
  });
}

export async function all(payload) {
  let url = "/surgical_intervention_transfers";
  return await HttpPostRequest(url, payload).then((response) => {
    return response.json();
  });
}
